import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';

const TopLevelClassContext = React.createContext(null);

const withTopLevelClass = () => (WrappedComponent) => {
  const ComponentWithTopLevelClass = props => (
    <TopLevelClassContext.Consumer>
      {topLevelClass => <WrappedComponent topLevelClass={topLevelClass} {...props} />}
    </TopLevelClassContext.Consumer>
  );

  ComponentWithTopLevelClass.propTypes = {
    ...omit(WrappedComponent.propTypes, 'topLevelClass'),
  };

  ComponentWithTopLevelClass.defaultProps = {
    ...omit(WrappedComponent.defaultProps, 'topLevelClass'),
  };

  return ComponentWithTopLevelClass;
};

export const TopLevelClassProvider = ({ topLevelClass, children }) => (
  <TopLevelClassContext.Provider value={topLevelClass}>{children}</TopLevelClassContext.Provider>
);

TopLevelClassProvider.propTypes = {
  topLevelClass: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default withTopLevelClass;
